// import {Platform} from "react-native";
//
// module.exports = Platform.OS === 'android' ? require("react-native-firebase") : null;


/**
 * @providesModule RNRestart
 */

'use strict';

let ImagePicker = null;
//const LottieView  = LottieView;
export default ImagePicker;
